// components/EmailConfirmationModal.jsx

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom'; // Import ReactDOM for the portal
import emailStyles from './EmailConfirmationModal.module.css'; // Import the specific styles for Email Confirmation Modal
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // Import FontAwesomeIcon component
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'; // Import the 'times circle' icon for the close button

const EmailConfirmationModal = ({ isOpen, onClose }) => {
  const [modalContainer, setModalContainer] = useState(null);

  useEffect(() => {
    // Set up the modal container for the portal
    const container = document.getElementById('modal-root');
    setModalContainer(container);
  }, []);

  // Return null if the modal is not open or the container is not available
  if (!isOpen || !modalContainer) return null;

  return ReactDOM.createPortal(
    <div
      className={emailStyles['email-confirmation-modal']}
      role="dialog"
      aria-modal="true"
      aria-labelledby="email-confirmation-modal-title"
    >
      {/* Close Button */}
      <button
        className={emailStyles['email-confirmation-modal-close']} // Ensure the correct class name is used here
        onClick={onClose}
        aria-label="Close modal"
      >
        <FontAwesomeIcon icon={faTimesCircle} size="2x" />
      </button>

      {/* Top URL Bar */}
      <div className={emailStyles['email-confirmation-modal-url-bar-top']}>
        <center className={emailStyles['modal-url']}>ShuffleDB.com</center>
      </div>

      {/* Modal Title */}
      <div
        id="email-confirmation-modal-title"
        className={emailStyles['email-confirmation-modal-title']}
      >
        Check Your Email
      </div>

      {/* Modal Body */}
      <div className={emailStyles['email-confirmation-modal-body']}>
        <h2>Please check your inbox to confirm your email address.</h2>
        <button className={emailStyles['set-password-button']} aria-label="Proceed to set your password">
          Set Your Password
        </button>
      </div>

      {/* Bottom URL Bar */}
      <div className={emailStyles['email-confirmation-modal-url-bar-bottom']}>
        <center className={emailStyles['modal-url']}>ShuffleDB.com</center>
      </div>
    </div>,
    modalContainer
  );
};

export default EmailConfirmationModal;
